<mat-tab-group animationDuration="0ms" [preserveContent]="true">
  <mat-tab>
    <ng-template mat-tab-label>
      <span>Details</span>
    </ng-template>
    <app-opb-details-tab [isEditMode]="isEditMode" [companyData]="companyData" />
  </mat-tab>
</mat-tab-group>
